import script from "./LodingComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./LodingComponent.vue?vue&type=script&setup=true&lang=ts"

import "./LodingComponent.vue?vue&type=style&index=0&id=27f6d33a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27f6d33a"]])

export default __exports__